export default class Maintenance {
  static update () {
    window.location = '/'
  }
}
